import React, {ReactElement} from 'react';
import {cx} from '@emotion/css';
import {HeaderDrawerProp, splitDrawerLinksIntoColumns} from './headerUtils';
import useOpenAndClosedTransition from '../../../../useOpenAndClosedTransition';
import DynamicLink from '../../../DynamicLink/DynamicLink';
import styles from './HeaderDrawer.styles';

type Props = {
  links: HeaderDrawerProp[];
  isOpen: boolean;
};

function HeaderDrawer({links, isOpen}: Props): ReactElement {
  const columnsData: HeaderDrawerProp[][] = splitDrawerLinksIntoColumns(links);
  const drawerContainerRef = useOpenAndClosedTransition(isOpen);

  return (
    <div className={cx(styles.headerDrawer(isOpen))} ref={drawerContainerRef}>
      <div className={cx(styles.linksContainer)}>
        {columnsData.map((entriesColumn: HeaderDrawerProp[], i: number) => (
          <div className={cx(styles.linkContainerColumn)} key={i.toString()}>
            {entriesColumn.map((entry: HeaderDrawerProp) => {
              // unstyledLink used for removing unneeded styles from link
              const headerDrawerLinkClassname = cx('unstyledLink', styles.headerDrawerLink(entry.isPrimary));

              return (
                <DynamicLink href={entry.href} className={cx(headerDrawerLinkClassname)} key={entry.label}>
                  {entry.label}
                </DynamicLink>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}

export default HeaderDrawer;
